module.exports = __webpack_public_path__ + "3a6bcb6fc1821e6a056d062752f3e733.svg";